<div
  [ngClass]="{'form-container aside' : config && config.aside_container, 'form-container': formtype == '', 'pb-5': config && config.floating_button, 'templateBlock': config && config.isTemplate, 'formBlock': config && !config.isTemplate}" #formContainer>
  @if (form || popupForm) {
    <form [focusInvalidInput]="form" (ngSubmit)="onSubmit()" [formGroup]="formtype == '' ? form:popupForm"
      class="form_{{(config && config.id != undefined)?config.id:'unknown'}}">
      <fieldset [disabled]="isInProgress">
        <div class="col-12 text-right mb-2">
          @if (config.QrCodeScan) {
            <button type="button" class="btn-with-icon-label" data-toggle="tooltip"
              data-placement="bottom" title="To Scan QR Code" (click)="QRCodeScanForm();">
              <i aria-hidden="true" class="fa fa-qrcode"></i>
              <span>{{'field.label.qr_code_scan' | translate | async }}</span>
            </button>
          }
          @if (config.AbhaAdd) {
            <button type="button" class="btn-with-icon-label" data-toggle="tooltip"
              data-placement="bottom" title="Add Patient by ABHA" (click)="AbhaAddForm();">
              <i aria-hidden="true" class="fa fa-id-card"></i>
              <span>{{'field.label.abha_add' | translate | async }}</span>
            </button>
          }
          @if (group_type == 'scroll-tab' || (config != undefined && config.isExpendRequired)) {
            <button type="button" class="btn-with-icon-label"
              data-toggle="tooltip" data-placement="bottom" title="To Expand/Collapse Form"
              (click)="expandColapseForm();">
              <i aria-hidden="true"
              [ngClass]="config.expanded_form ? 'fa fa-compress fa-lg rotate-45' : 'fa fa-expand fa-lg rotate-45'"></i>
              <span>{{'field.label.expand_collapse' | translate | async }}</span>
            </button>
          }
        </div>
        @if (bookmarks != undefined && bookmarks && bookmarks.bookmark && bookmarks.bookmark.visible!=false) {
          <app-bookmarks [bookmarks]="bookmarks" (Entity)="bookmarkAdded($event,bookmarks.bookmark.type)"
            (Favourite)="favouriteList($event)" #bookmarkRef>
          </app-bookmarks>
        }
        <ng-container [ngTemplateOutlet]="blockRenderer"
          [ngTemplateOutletContext]="{fieldGroups:fieldGroups, type: type}">
        </ng-container>
        @if (formtype == '' && config && config.buttons == undefined) {
          @if (aiFill.load) {
            <app-kx-ai-filling [config]="aiFill" class="ai-fill-button"></app-kx-ai-filling>
          }
          <div class="row form-primary-actions sticky-add-btn mt-3" [ngClass]="getClassForButton()">
            @if (config && config.filterForm) {
              <div class="col-6 text-right">
                <!--form clear/reset button-->
                <button type="button" (click)="resetFormClick()" class="secondary-btn">
                  {{'button.clear' | translate | async}}
                  <i class="fa fa-times-circle ml-2" aria-hidden="true"></i>
                </button>
              </div>
            }
            <div id="showButtons"
              [ngClass]="config && config.filterForm === true ? 'col-6':'col-12 text-center'">
              @if (((fieldGroup.showButtons == undefined || !fieldGroup.showButtons) && (submitButton && config.clearOnSave) && config.cancelButton)) {
                <button type="button"
                  (click)="cancelButtonClick()" class="secondary-btn">
                  {{'button.cancel' | translate | async}}
                  <img src="assets/images/btn-icons/platform icons_button-cancel.svg" />
                </button>
              }
              <!-- <button type="button" *ngIf="fieldGroup.resetForm" (click)="resetFormClick()"
              class="secondary-btn">
              {{fieldGroup.resetForm.label  | translate | async}}
            </button> -->
            @for (btn of saveButton; track btn) {
              @if (btn.type != undefined) {
                @if (((fieldGroup.showButtons == undefined || !fieldGroup.showButtons) && config.submitButton && !btn.disabled)) {
                  <button class="aside-fixed-button" [type]="btn.type ? btn.type : 'button'"
                    [disabled]="btn.disabled != undefined ? btn.disabled : false"
                    [ngClass]="btn.btnClass != undefined ? btn.btnClass : 'primary-btn submitButton'"
                    (click)="btn.type != 'submit' ? customButtonEvent(btn):emitButtonInfo(btn)">
                    {{ btn.label | translate | async }}
                    @if (btn.icon!=undefined) {
                      <i class="fa {{btn.icon}} ml-2" aria-hidden="true"></i>
                    }
                  </button>
                }
                @if (btn.tooltip != undefined && btn.action_name == 'previous') {
                  <div class="prev-btn">
                  {{btn.tooltip}}</div>
                }
                @if (btn.tooltip != undefined && btn.action_name != 'previous' && (btn.disabled!=undefined ? !btn.disabled : true)) {
                  <div
                    class="prev-btn pointer-btn-next" (click)="customButtonEvent(btn, 'next')">Skip to
                  {{btn.tooltip}}</div>
                }
              }
              @if (((fieldGroup.showButtons == undefined || !fieldGroup.showButtons) && submitButton && config.submitButton && btn.type == undefined)) {
                <button type="submit" class="aside-fixed-button primary-btn submitButton"
                  (click)="emitButtonInfo(btn)">
                  {{ btn.label | translate | async }}
                  @if (btn.icon!=undefined) {
                    <i class="fa {{btn.icon}} ml-2" aria-hidden="true"></i>
                  }
                </button>
              }
            }
          </div>
        </div>
      }
      <!--for composite array-->
      @if (formtype != '') {
        <div class="composite-aside-btn col-sm-12 text-center mt-1 d-inline-block form-action-button-container"
          [ngClass]='config!=undefined && config.composite_form!=undefined && config.composite_form?"floating_composite_button":""'>
          @if (saveButton!=undefined && saveButton.label) {
            <button type="submit" class="secondary-btn">
              {{ saveButton.label | translate | async}}
            </button>
          }
          @for (btn of saveButton; track btn) {
            <button type="submit" [ngClass]="btn.buttonClass != undefined ? btn.buttonClass : 'secondary-btn'" [disabled]="config.btnDisabled"
              (click)="emitButtonInfo(btn)" class="aside-fixed-button">
              {{ btn.label | translate | async }}
              @if (btn.icon!=undefined) {
                <i class="fa {{btn.icon}} ml-2" aria-hidden="true"></i>
              }
            </button>
          }
        </div>
      }
    </fieldset>
  </form>
}
@if (casesheet) {
  <app-aside-bar-tabs [casesheet_data]="casesheet" (clickTab)="tabclick($event)"></app-aside-bar-tabs>
}
</div>

<ng-template #blockRenderer let-fieldGroups='fieldGroups' let-type='type'>
  <!-- <span class="d-none">&nbsp;</span> -->
  @if (group_type != 'tab' && group_type != 'scroll-tab') {
    @for (fieldg of fieldGroups ; track fieldg; let i = $index) {
      <!-- <div [ngClass]="fieldg['className'] != null && fieldg['className'] != undefined ? fieldg['className'] : ''"> -->
      @if (fieldg['group_type']=='blocks' || fieldg['group_type']=='') {
        <div class="block"
          [ngClass]="fieldg['layout_type'] == 'no-column'? fieldg['layout_type'] + ' ' +fieldg['className'] : fieldg['layout_type']"
          [id]="fieldg['name']">
          @if (fieldg['title'] && fieldg['visible'] && type == undefined) {
            <div class="block-heading-container">
              <div class="block-heading">{{fieldg['title'] | translate | async}}</div>
              <div class="headingline"></div>
            </div>
          }
          <!-- <div class="form-group m-2"> -->
          @for (question of fieldg.questions; track question) {
            @if (!isArray(question)) {
              <dhs-form-question [action]="action" [layout_type]="fieldg['layout_type']" [question]="question"
                [form]="formtype == '' ? form:popupForm" (valueChanged)="onValueChanged($event)"
                [decorator]="decorator" [validIn]="validIn" (setConfig)="setConfig($event)"
                (customButtonEventFired)="customButtonEvent($event)" [config]="config"
                (runTimeQuestions)="createRuntimeQuestions($event)" (getData)="getDataFn($event)"
                (multiselectClose)="closeDropdown($event)"
                >
              </dhs-form-question>
            }
            @if (isArray(question)) {
              @if (question.label && fieldg['visible']) {
                <div class="block-sub-heading">
                  {{question.label | translate | async}}
                </div>
              }
              <ng-container [ngTemplateOutlet]="blockRenderer"
                [ngTemplateOutletContext]="{fieldGroups:question}">
              </ng-container>
            }
          }
          <!-- <ng-container *ngIf="fieldg.fields">
          <dhs-score [fields]="fieldg.fields" [scoreData]="fieldg.scoreData" [blockId]="fieldg.block_id" [blockName]="fieldg.title" (valueAdded)="scoreEvent($event);" [data]="data" [current_action]="action"></dhs-score>
        </ng-container> -->
      <!-- </div> -->
    </div>
  }
<!-- </div> -->
<!-- For Accordian -->
@if (fieldg['group_type']=='accordian'&&fieldg['visible']) {
  <div class="row accordion-container"
    style="width: 100%;float: left;">
    <div class="col-12 p-0">
      <div [id]="'accordion' + accUid + '-' + i" class="accordion p-0 " (keyup.enter)="fieldg.default_open = true"
        role="presentation" tabindex="0">
                        <div class="shadow-common-accordion" [ngClass]="{'border-danger': validIn && !fieldg.valid,
                    'collapsed': fieldg.default_open!=true}" data-toggle="collapse" [attr.data-target]="'#acc' + accUid + '-' + i"
          (click)="showId(('acc' + accUid + '-' + i),(('accordion' + accUid + '-' + i)));">
          <div class="d-flex align-items-center justify-content-between p-2">
            <div class="">
              <a class="accordion-title">
                {{fieldg['title'] | translate | async}}
              </a>
            </div>
            <div class="accordion-icon p-0">
              <i class="fa fa-angle-down" aria-hidden="true"></i>
            </div>
          </div>
        </div>
        <!-- space given show have relevance at ng class as to distinguish fieldg.name + ' show' -->
        <div [id]="'acc' + accUid + '-' + i"
          [ngClass]="fieldg.default_open!=undefined&&fieldg.default_open===true ?fieldg.name + ' show':fieldg.name"
          class="accordion-body collapse" [attr.data-parent]="'#accordion' + accUid + '-' + i">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xs-12 p-3">
            <div class="row">
              <div class="col-12">
                <div class="block"
                  [ngClass]="fieldg['layout_type'] == 'no-column'? fieldg['layout_type'] + ' ' +fieldg['className'] : fieldg['layout_type']">
                  @for (question of fieldg.questions; track question) {
                    @if (!isArray(question)) {
                      <dhs-form-question [decorator]="decorator"
                        [layout_type]="fieldg['layout_type']" [action]="action"
                        [validIn]="validIn" [question]="question" [form]="form"
                        (valueChanged)="onValueChanged($event)" [config]="config"
                        (getData)="getDataFn($event)" (setConfig)="setConfig($event)"
                        (runTimeQuestions)="createRuntimeQuestions($event)">
                      </dhs-form-question>
                    }
                    @if (isArray(question)) {
                      @if (question.label) {
                        <div class=" composite_block">
                          {{question.label | translate | async}}
                        </div>
                      }
                      <ng-container [ngTemplateOutlet]="blockRenderer"
                        [ngTemplateOutletContext]="{fieldGroups:question}">
                      </ng-container>
                    }
                  }
                </div>
                <!-- <ng-container *ngIf="fieldg.fields">
                <dhs-score [fields]="fieldg.fields" [scoreData]="fieldg.scoreData" [blockId]="fieldg.block_id" [blockName]="fieldg.title" [data]="data" (valueAdded)="scoreEvent($event);" [current_action]="action">
                </dhs-score>
              </ng-container> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
}
<!-- </div> -->
}
}
<!-- For vertical list group -->
@if (group_type == 'tab') {
  <div class="row">
    <ng-container>
      <div class="col-3 cstm-list-group pr-0">
        <div class="nav flex-column nav-pills" role="tablist" id="v-pills-tab">
          @for (fieldg of fieldGroups ; track fieldg; let i = $index) {
            @if (fieldg['group_type']=='tab'&&fieldg['visible']) {
              <a class="nav-link" data-toggle="list"
                [ngClass]="[ (fieldg['name'] == activeKey) ?validIn ? 'active show form-tab-err':'active show' : 'bg-white',(validIn && !fieldg.valid)?'border-danger': '']"
                id="{{fieldg['name']}}tab" role="tab" (click)="activeTab(fieldg['name'],$event)"
                >{{fieldg['title'] | translate |
              async}}</a>
            }
          }
        </div>
      </div>
      <div class="col-9 cstm-tab-pane">
        <div class="tab-content">
          @for (fieldg of fieldGroups ; track fieldg; let i = $index) {
            <div class="tab-pane cstm-v-tab-pane"
              id="{{fieldg['name']}}" role="tabpanel"
              [ngClass]="fieldg['name'] == activeKey ? 'active show' : 'fade'">
              @for (question of fieldg.questions; track question) {
                @if (!isArray(question)) {
                  <dhs-form-question [decorator]="decorator" [layout_type]="fieldg['layout_type']"
                    [action]="action" [question]="question" [form]="form" (setConfig)="setConfig($event)"
                    (valueChanged)="onValueChanged($event)" [validIn]="validIn" [config]="config"
                    (getData)="getDataFn($event)" (runTimeQuestions)="createRuntimeQuestions($event)">
                  </dhs-form-question>
                }
                @if (isArray(question)) {
                  @if (question.label) {
                    <div class=" composite_block">
                    {{question.label | translate | async}}</div>
                  }
                  <ng-container [ngTemplateOutlet]="blockRenderer"
                    [ngTemplateOutletContext]="{fieldGroups:question}">
                  </ng-container>
                }
              }
              <!-- <ng-container *ngIf="fieldg.fields">
              <dhs-score [fields]="fieldg.fields" [scoreData]="fieldg.scoreData" [blockId]="fieldg.block_id" [blockName]="fieldg.title" (valueAdded)="scoreEvent($event);"></dhs-score>
            </ng-container> -->
          </div>
        }
      </div>
    </div>
  </ng-container>
</div>
}

<!-- For scroll-tab -->
@if (group_type == 'scroll-tab') {
  <div class="row vertical-form pl-3 pr-3">
    @if (type == undefined && !utilService.isMobile()) {
      <div class="vertical-form-actions cstm-list-group pr-0">
        <div class="nav flex-column nav-pills position-sticky" role="tablist" #tabRef id="v-pills-tab"
          style="top: 58px;">
          @for (fieldg of fieldGroups ; track fieldg; let i = $index) {
            @if (fieldg['title']) {
              @if (fieldg['visible']) {
                <a class="nav-link" data-toggle="list"
                  [ngClass]="[(fieldg['name'] == activeKey) ?validIn ? 'active show form-tab-err':'active show' : '']"
                  (click)="navigateToSection(fieldg['name'], fieldg['block_id'])"
                >{{fieldg['title'] | translate | async}}</a>
              }
            }
          }
        </div>
      </div>
    }
    <div [ngClass]="type==undefined && !utilService.isMobile() ? 'vertical-form-body': 'col-12 p-0'">
      @for (fieldg of fieldGroups ; track fieldg; let i = $index) {
        <!-- <div [ngClass]="type==undefined ? 'card-layout' : ''" [id]="fieldg['name']" *ngIf="fieldg['visible']"> -->
        @if (fieldg['visible']) {
          <div class="block box-shadow mb-2 patient-registration-shadow"
            [ngClass]="fieldg['layout_type'] == 'no-column'? fieldg['layout_type'] + ' ' +fieldg['className'] : fieldg['layout_type']"
            [id]="fieldg['name']">
            <!-- <div class="col-12 kx-block-sub-title" *ngIf="fieldg['title'] &&fieldg['visible'] ">
            {{fieldg['title'] | translate | async}}
          </div> -->
          @if (fieldg['title'] && fieldg['visible'] && type == undefined) {
            <div class="block-heading-container"
              (click)="openScrollBox(fieldg['name'],fieldg['block_id'])">
              <div class="block-heading">{{fieldg['title'] | translate | async}}</div>
              <div class="headingline"></div>
              <div class="ml-4">
                <i class="fa fa-angle-down" style="font-weight: bolder;font-size: 18px;"></i>
              </div>
            </div>
          }
        <!-- </div> -->
        @if (bookmarks != undefined && bookmarks) {
          <app-bookmarks [bookmarks]="bookmarks" (Entity)="bookmarkAdded($event,bookmarks.bookmark.type)"
            (Favourite)="favouriteList($event)">
          </app-bookmarks>
        }
        <!-- [hidden]="fieldg.default_open == false" -->
        <div [hidden]="!fieldg.default_open" class="block"
          [ngClass]="fieldg['layout_type'] == 'no-column'? fieldg['layout_type'] + ' ' +fieldg['className'] : fieldg['layout_type']">
          @for (question of fieldg.questions; track question) {
            @if (!isArray(question)) {
              <dhs-form-question [decorator]="decorator" [action]="action" [question]="question"
                [layout_type]="fieldg['layout_type']" [form]="form" (setConfig)="setConfig($event)"
                (valueChanged)="onValueChanged($event)" [validIn]="validIn" [config]="config"
                (getData)="getDataFn($event)" (runTimeQuestions)="createRuntimeQuestions($event)">
              </dhs-form-question>
            }
            @if (isArray(question)) {
              @if (question.label) {
                <div>
                {{question.label | translate | async}}</div>
              }
              <ng-container [ngTemplateOutlet]="blockRenderer"
                [ngTemplateOutletContext]="{fieldGroups:question, type: 'arrayForm'}">
              </ng-container>
            }
          }
          <!-- <ng-container *ngIf="fieldg.fields">
          <dhs-score [fields]="fieldg.fields" [scoreData]="fieldg.scoreData"
            [blockId]="fieldg.block_id" [blockName]="fieldg.title"
          (valueAdded)="scoreEvent($event);"></dhs-score>
        </ng-container> -->
      </div>
    </div>
  }
<!-- </div> -->
}
</div>
</div>
}
</ng-template>